.hero {
  position: absolute;
  position-anchor: --viewport;
  position-area: center center;
  place-self: center;
  align-self: center;
  display: flex;
  flex-flow: column nowrap;
  gap: var(--mantine-spacing-md);
  align-items: center;
  justify-content: center;
  contain: layout;
  mix-blend-mode: screen;
  pointer-events: none;
}

.spinner {
  width: 30cqmin;
  max-width: 30rem;
  margin-bottom: -5cqmin;
  mix-blend-mode: screen;
}
